import React, { useState } from 'react';
import { 
  Table, Card, Button, Space, Typography, Form, Input, Select, Upload, Cascader,
  Tag, Alert, Drawer, Descriptions, Radio, message, Modal
} from 'antd';
import { SearchOutlined, ReloadOutlined, CloudUploadOutlined, DownloadOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;

const ENT_CASCADE = [
  { value: 'partner', label: '合作企业', children: [
    { value: 'HZ-ZL-001', label: '杭州智联科技有限公司' },
  ]},
  { value: 'child', label: '下级企业', children: [
    { value: 'CD-YS-002', label: '成都云视科技有限公司' },
    { value: 'GZ-YL-002', label: '广州云联物联网有限公司' },
  ]},
];

const AgentDistribution = () => {
  const [form] = Form.useForm();
  const [detailVisible, setDetailVisible] = useState(false);
  const [detailRecord, setDetailRecord] = useState(null);
  const [detailTitle, setDetailTitle] = useState('');
  const [reDistVisible, setReDistVisible] = useState(false);
  const [reDistForm] = Form.useForm();
  const [reDistMode, setReDistMode] = useState('all');
  const [reDistParent, setReDistParent] = useState(null);

  const agentData = [
    { key: 'a1', batchNo: 'AG202604-001', productName: '智能摄像机Q1', productId: 'PROD_Q1', parentName: '深圳星辰物联科技有限公司', parentId: 'SZ-XC-001', deviceCount: 500, reDistTotal: 320, time: '2026-04-01 10:00:00',
      devices: [
        { key: 'al1', license: 'LIC_A001', productName: '智能摄像机Q1', productId: 'PROD_Q1', status: '已激活' },
        { key: 'al2', license: 'LIC_A002', productName: '智能摄像机Q1', productId: 'PROD_Q1', status: '已激活' },
        { key: 'al3', license: 'LIC_A003', productName: '智能摄像机Q1', productId: 'PROD_Q1', status: '未激活' },
      ],
      subRows: [
        { key: 'a1-r1', batchNo: 'RD202604-001', targetName: '杭州智联科技有限公司', targetId: 'HZ-ZL-001', deviceCount: 200, time: '2026-04-03 09:00:00',
          devices: [
            { key: 'rl1', license: 'LIC_A001', productName: '智能摄像机Q1', productId: 'PROD_Q1', status: '已激活' },
            { key: 'rl2', license: 'LIC_A002', productName: '智能摄像机Q1', productId: 'PROD_Q1', status: '已激活' },
          ]
        },
        { key: 'a1-r2', batchNo: 'RD202604-002', targetName: '成都云视科技有限公司', targetId: 'CD-YS-002', deviceCount: 120, time: '2026-04-05 14:00:00',
          devices: [
            { key: 'rl3', license: 'LIC_A003', productName: '智能摄像机Q1', productId: 'PROD_Q1', status: '未激活' },
          ]
        },
      ]
    },
    { key: 'a2', batchNo: 'AG202604-002', productName: '云台机P1', productId: 'PROD_P1', parentName: '深圳星辰物联科技有限公司', parentId: 'SZ-XC-001', deviceCount: 300, reDistTotal: 0, time: '2026-03-28 14:30:00',
      devices: [
        { key: 'al4', license: 'LIC_B001', productName: '云台机P1', productId: 'PROD_P1', status: '已激活' },
        { key: 'al5', license: 'LIC_B002', productName: '云台机P1', productId: 'PROD_P1', status: '未激活' },
      ],
      subRows: []
    },
  ];

  const openDetail = (record, title) => {
    setDetailRecord(record);
    setDetailTitle(title);
    setDetailVisible(true);
  };

  const parentColumns = [
    { title: '上级分销批次', dataIndex: 'batchNo', width: 150, render: (t) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 13 }}>{t}</Text> },
    { title: '上级分销', key: 'parent', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.parentName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.parentId}</Text></div>) },
    { title: '产品信息', key: 'product', width: 160, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.productName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.productId}</Text></div>) },
    { title: '分销设备数', dataIndex: 'deviceCount', width: 120, align: 'right', render: (v, r) => <Button type="link" style={{ padding: 0, fontWeight: 600 }} onClick={() => openDetail(r, `分销详情 - ${r.batchNo}`)}>{v} 台</Button> },
    { title: '再分销总数', dataIndex: 'reDistTotal', width: 110, align: 'right', render: (v) => <Text strong>{v} 台</Text> },
    { title: '分销时间', dataIndex: 'time', width: 170, render: (t) => <Text type="secondary">{t}</Text> },
    { title: '操作', key: 'action', width: 100, render: (_, r) => <Button type="link" size="small" onClick={() => { reDistForm.resetFields(); setReDistParent(r); setReDistMode('all'); setReDistVisible(true); }}>再分销</Button> },
  ];

  const childColumns = [
    { title: '#', width: 50, align: 'center', render: (_, __, i) => <Text type="secondary">{i + 1}</Text> },
    { title: '再分销批次', dataIndex: 'batchNo', width: 150, render: (t) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 13 }}>{t}</Text> },
    { title: '分销下级', key: 'target', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.targetName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.targetId}</Text></div>) },
    { title: '再分销设备', dataIndex: 'deviceCount', width: 120, align: 'right', render: (v, r) => <Button type="link" style={{ padding: 0, fontWeight: 600 }} onClick={() => openDetail(r, `再分销详情 - ${r.batchNo}`)}>{v} 台</Button> },
    { title: '再分销时间', dataIndex: 'time', width: 170, render: (t) => <Text type="secondary">{t}</Text> },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}><Title level={4}>代理设备分销</Title></div>
      <Alert type="info" showIcon style={{ marginBottom: 8, borderRadius: 8 }}
        message={<div>
          <div>你的可将你经销的设备继续分配给你的下级进行销售，一台设备（License）只能分销给一个分销下级企业。</div>
        </div>}
      />
      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }} bodyStyle={{ padding: '12px 0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Form form={form} layout="inline" style={{ flex: 1, gap: 0 }}>
            <Form.Item name="distBatch" style={{ marginRight: 8 }}><Input placeholder="上级分销批次号" allowClear style={{ width: 160 }} /></Form.Item>
            <Form.Item name="reDistBatch" style={{ marginRight: 8 }}><Input placeholder="再分销批次号" allowClear style={{ width: 160 }} /></Form.Item>
            <Form.Item name="license" style={{ marginRight: 8 }}><Input placeholder="License" allowClear style={{ width: 160 }} /></Form.Item>
            <Form.Item style={{ marginRight: 8 }}>
              <Space.Compact>
                <Form.Item name="parentType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">上级分销</Option><Option value="id">上级ID</Option></Select></Form.Item>
                <Form.Item shouldUpdate={(p, c) => p.parentType !== c.parentType} noStyle>
                  {({ getFieldValue }) => getFieldValue('parentType') === 'id' ? (<Form.Item name="parent" noStyle><Input placeholder="上级ID" allowClear style={{ width: 200 }} /></Form.Item>) : (<Form.Item name="parent" noStyle><Select placeholder="请选择上级分销" allowClear showSearch optionFilterProp="label" style={{ width: 200 }} options={agentData.map(d => ({ value: d.parentId, label: d.parentName })).filter((v, i, a) => a.findIndex(t => t.value === v.value) === i)} /></Form.Item>)}
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item style={{ marginRight: 8 }}>
              <Space.Compact>
                <Form.Item name="entType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">分销下级</Option><Option value="id">下级ID</Option></Select></Form.Item>
                <Form.Item shouldUpdate={(p, c) => p.entType !== c.entType} noStyle>
                  {({ getFieldValue }) => getFieldValue('entType') === 'id' ? (<Form.Item name="ent" noStyle><Input placeholder="下级企业ID" allowClear style={{ width: 200 }} /></Form.Item>) : (<Form.Item name="ent" noStyle><Cascader placeholder="请选择分销下级企业" showSearch style={{ width: 200 }} options={ENT_CASCADE} /></Form.Item>)}
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item style={{ marginRight: 8 }}>
              <Space.Compact>
                <Form.Item name="prodType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">产品名称</Option><Option value="id">产品ID</Option></Select></Form.Item>
                <Form.Item shouldUpdate={(p, c) => p.prodType !== c.prodType} noStyle>
                  {({ getFieldValue }) => getFieldValue('prodType') === 'id' ? (<Form.Item name="prod" noStyle><Input placeholder="产品ID" allowClear style={{ width: 200 }} /></Form.Item>) : (<Form.Item name="prod" noStyle><Select placeholder="请选择产品" allowClear showSearch optionFilterProp="label" style={{ width: 200 }} options={[...new Set(agentData.map(d => d.productName))].map(n => ({ value: n, label: n }))} /></Form.Item>)}
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item style={{ marginRight: 0 }}><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button></Space></Form.Item>
          </Form>
        </div>
      </Card>
      <Card bordered={false}>
        <Table columns={parentColumns} dataSource={agentData} rowKey="key"
          expandable={{ expandedRowRender: (record) => (
            <div style={{ marginLeft: 80 }}>
            <Table columns={childColumns} dataSource={record.subRows} rowKey="key" size="small" pagination={false}
              locale={{ emptyText: '暂无再分销记录' }}
            />
            </div>
          )}}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
        />
      </Card>

      <Drawer title={detailTitle} width={700} onClose={() => setDetailVisible(false)} open={detailVisible} destroyOnClose>
        {detailRecord && (<>
          <Descriptions bordered column={2} size="small" style={{ marginBottom: 16 }}>
            <Descriptions.Item label="批次号">{detailRecord.batchNo}</Descriptions.Item>
            <Descriptions.Item label="设备数量"><Text strong>{detailRecord.deviceCount} 台</Text></Descriptions.Item>
            {detailRecord.parentName && <Descriptions.Item label="上级分销">{detailRecord.parentName}</Descriptions.Item>}
            {detailRecord.targetName && <Descriptions.Item label="分销下级">{detailRecord.targetName}</Descriptions.Item>}
            <Descriptions.Item label="分销时间">{detailRecord.time}</Descriptions.Item>
          </Descriptions>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <Text strong>设备列表</Text>
            <Button size="small" icon={<DownloadOutlined />} onClick={() => message.success('导出成功')}>导出</Button>
          </div>
          <Table size="small" dataSource={detailRecord.devices} rowKey="key"
            pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 台设备` }}
            columns={[
              { title: 'License', dataIndex: 'license', render: (t) => <Text copyable style={{ fontFamily: 'monospace' }}>{t}</Text> },
              { title: '所属产品', key: 'product', render: (_, r) => (<div><div>{r.productName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.productId}</Text></div>) },
              { title: '设备状态', dataIndex: 'status', render: (v) => <Tag color={v === '已激活' ? 'green' : 'default'}>{v}</Tag> },
            ]}
          />
        </>)}
      </Drawer>

      <Drawer title={`再分销 - ${reDistParent?.batchNo || ''}`} width={640} onClose={() => setReDistVisible(false)} open={reDistVisible} destroyOnClose
        footer={<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 16px' }}>{/* TODO: 联调时根据接口校验结果动态展示 */}<Button type="link" danger size="small" onClick={() => Modal.error({ title: '不可再分销设备', width: 520, okText: '我知道了', content: (<div><div style={{ marginBottom: 8 }}>存在 10 台设备（License）不可再分销。</div><div style={{ background: '#fff2f0', padding: '8px 12px', borderRadius: 6, border: '1px solid #ffccc7', fontSize: 12 }}>LIC_301、LIC_302、LIC_303、LIC_304、LIC_305、LIC_306、LIC_307、LIC_308、LIC_309、LIC_310</div></div>) })}>点击查看错误提示</Button><Space><Button onClick={() => setReDistVisible(false)}>取消</Button><Button type="primary" onClick={() => { message.success('再分销已发起'); setReDistVisible(false); }}>确认再分销</Button></Space></div>}
      >
        {reDistParent && (
          <Form form={reDistForm} layout="vertical">
            <div style={{ background: '#f6ffed', padding: '10px 14px', borderRadius: 6, border: '1px solid #b7eb8f', marginBottom: 16 }}>
              <Text>来源批次：<Text strong>{reDistParent.batchNo}</Text>，上级分销设备：<Text strong>{reDistParent.deviceCount}</Text> 台，当前可分销设备：<Text strong style={{ color: '#52c41a' }}>{reDistParent.deviceCount - reDistParent.reDistTotal}</Text> 台</Text>
            </div>
            <div style={{ marginBottom: 16 }}>
              <Button icon={<DownloadOutlined />} onClick={() => message.success('下载成功')}>下载可再分销设备</Button>
            </div>
            <Form.Item label="分配方式" required style={{ marginBottom: 16 }}>
              <Radio.Group value={reDistMode} onChange={(e) => setReDistMode(e.target.value)}>
                <Radio value="all">当前所有设备</Radio>
                <Radio value="import">自定义导入</Radio>
              </Radio.Group>
            </Form.Item>
            {reDistMode === 'all' && (
              <div style={{ background: '#f6ffed', padding: '8px 14px', borderRadius: 6, border: '1px solid #b7eb8f', marginBottom: 16 }}>
                <Text>分销设备数：<Text strong style={{ color: '#52c41a' }}>{reDistParent.deviceCount - reDistParent.reDistTotal}</Text> 台</Text>
              </div>
            )}
            {reDistMode === 'import' && (
              <Form.Item name="licenses" label="导入再分销设备（License）" rules={[{ required: true, message: '请上传' }]} extra="仅可选择该批次中尚未再分销的设备，单次最多5000个License。">
                <Upload.Dragger maxCount={1} beforeUpload={() => false} style={{ background: '#fff' }}>
                  <p className="ant-upload-drag-icon"><CloudUploadOutlined /></p>
                  <p className="ant-upload-text">点击或拖拽License文件上传</p>
                  <p className="ant-upload-hint">支持 xlsx/xls 格式，单次最多5000条</p>
                </Upload.Dragger>
              </Form.Item>
            )}
            <Form.Item name="targetId" label="分销下级" rules={[{ required: true, message: '请选择' }]}>
              <Cascader placeholder="请选择分销下级企业" showSearch options={ENT_CASCADE} style={{ width: '100%' }} />
            </Form.Item>
          </Form>
        )}
      </Drawer>
    </div>
  );
};

export default AgentDistribution;
